export default [
  {
    name: 'point_budget',
    path: '/point_budget',
    component: () =>
      import(
        /* webpackChunkName: "point_budget" */ '@/projects/teller/views/PointBudget/index.vue'
      )
  }
]
